<template>
  <button
    v-show="showButton"
    @click="scrollToTop"
    class="scroll-to-top"
    :class="{ 'scroll-to-top_floating': floating }"
    aria-label="Scroll to top"
  >
    <AppIcon name="chevronUp" :size="20" />
  </button>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "ScrollToTop",

  components: {
    AppIcon,
  },

  props: {
    floating: {
      type: Boolean,
      default: true,
    },
    scrollContainerSelector: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      showButton: false,
      scrollContainer: null,
    };
  },
  mounted() {
    this.scrollContainer = this.findScrollContainer();
    if (this.scrollContainer) {
      this.scrollContainer.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeUnmount() {
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener(
        "scroll",
        this.handleScroll
      );
    }
  },
  methods: {
    findScrollContainer() {
      if (this.scrollContainerSelector) {
        return document.querySelector(this.scrollContainerSelector) || window;
      }

      // Ищем ближайший родительский элемент с overflow-y: auto/scroll
      let el = this.$el.parentElement;
      while (el) {
        const style = window.getComputedStyle(el);
        if (
          style.overflowY === "auto" ||
          style.overflowY === "scroll"
        ) {
          return el;
        }
        el = el.parentElement;
      }
      return window; // Возвращаем window, если не нашли подходящий контейнер
    },
    handleScroll() {
      const scrollContainer = this.scrollContainer || this.findScrollContainer();
      const scrollHeight =
        scrollContainer === window
          ? document.documentElement.scrollHeight
          : scrollContainer.scrollHeight;
      const clientHeight =
        scrollContainer === window
          ? window.innerHeight
          : scrollContainer.clientHeight;
      const scrollTop =
        scrollContainer === window
          ? window.pageYOffset
          : scrollContainer.scrollTop;

      const isPageTallEnough = scrollHeight > clientHeight * 2;
      this.showButton =
        isPageTallEnough && scrollTop > clientHeight * 0.8;
    },
    scrollToTop() {
      const scrollContainer = this.scrollContainer || this.findScrollContainer();
      if (scrollContainer) {
        scrollContainer.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>

<style scoped>
.scroll-to-top {
  width: var(--app-floating-action-size, 48px);
  height: var(--app-floating-action-size, 48px);
  border-radius: 50%;
  background: var(--color-green);
  color: white;
  border: none;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  transition: opacity 0.3s;
}

.scroll-to-top_floating {
  position: fixed;
  right: 20px;
  bottom: 80px;
}

.scroll-to-top:hover {
  background: #029882;
}
</style>
